import { render, staticRenderFns } from "./businessManagerCurrentAccount.vue?vue&type=template&id=dd3dcd10&scoped=true"
import script from "./businessManagerCurrentAccount.vue?vue&type=script&lang=js"
export * from "./businessManagerCurrentAccount.vue?vue&type=script&lang=js"
import style0 from "./businessManagerCurrentAccount.vue?vue&type=style&index=0&id=dd3dcd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3dcd10",
  null
  
)

export default component.exports